/** The earlier attempt of the same test, as the API sends it. */
export interface PreviousAttemptInfo {
  percentage: number;
  /** IELTS overall band of that attempt. */
  band: number | null;
  /** SAT total of that attempt. */
  total: number | null;
}

export interface AttemptDelta {
  kind: 'band' | 'score' | 'percent';
  value: number;
}

/**
 * How this attempt moved from the previous one, in the unit the exam is read in: bands for IELTS, points for SAT,
 * otherwise the share correct. Null when there is no earlier attempt.
 */
export function attemptDelta(
  current: { band?: number | null; total?: number | null; percentage: number },
  previous: PreviousAttemptInfo | null | undefined,
): AttemptDelta | null {
  if (!previous) return null;
  if (typeof current.band === 'number' && typeof previous.band === 'number') return { kind: 'band', value: current.band - previous.band };
  if (typeof current.total === 'number' && typeof previous.total === 'number') return { kind: 'score', value: current.total - previous.total };
  return { kind: 'percent', value: current.percentage - previous.percentage };
}

/** "+0.5", "-40", "+7%": always signed, so a zero change reads as "0". */
export function formatDelta(delta: AttemptDelta): string {
  const rounded = delta.kind === 'band' ? Math.round(delta.value * 10) / 10 : Math.round(delta.value);
  const text = delta.kind === 'band' ? rounded.toFixed(1) : String(rounded);
  const signed = rounded > 0 ? `+${text}` : rounded < 0 ? text.replace('-', '−') : '0';
  return delta.kind === 'percent' ? `${signed}%` : signed;
}
